import React from "react";
import { observer } from "mobx-react-lite";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { isGamesTheme } from "@utils";
import { WrappedLink } from "@components/navigation";
import { useRootAppStore } from "@hooks";
import { useAppContext } from "@state/hooks/shared";

export default observer(function HeaderLogo() {
	const { culture } = useAppContext();
	const rootStore = useRootAppStore();

	return (
		<figure className="header__figure">
			<WrappedLink
				to={`/${culture}/${DefaultPath.HOME}`}
				className="header__figure__link"
			>
				{rootStore.themeStore.isLightTheme ? (
					<>
						<img
							className="header__logo"
							src="/assets/images/logo-dark.svg"
							alt=""
						/>
						<div className="header__logo--sml" />
					</>
				) : (
					<>
						<img
							className="header__logo"
							src="/assets/images/logo.svg"
							alt=""
						/>
						<div className="header__logo--sml" />
					</>
				)}

				{isGamesTheme() && (
					<figcaption className="header__logo__text">
						Games
					</figcaption>
				)}
			</WrappedLink>
		</figure>
	);
});
